import { Option } from "@cartographerio/fp";
import { uniqBy } from "lodash-es";
/** A colletion of `SurveyModules`. One day we'll deprecate this in favour of loading surveys from the server. */
export class SurveyModuleInventory {
    constructor(modules) {
        /** Return a new SurveyModuleInventory including the specified module. */
        this.addSurveyModule = (module) => new SurveyModuleInventory([...this._modules, module]);
        /** Return a new SurveyModuleInventory without the specified module. */
        this.removeSurveyModule = (moduleId) => new SurveyModuleInventory(this._modules.filter(module => module.moduleId !== moduleId));
        /** Returns a list of all survey modules. */
        this.surveyModules = () => {
            return this._modules;
        };
        /** Returns a list of all survey module IDs. */
        this.surveyModuleIds = () => {
            return this._modules.map(module => module.moduleId);
        };
        /** Returns a SurveyModule given an ID. */
        this.surveyModuleById = (id) => {
            return Option.wrap(this._modulesById[id]);
        };
        this._modules = uniqBy(modules, module => module.moduleId);
        this._modulesById = Object.fromEntries(modules.map(module => [module.moduleId, module]));
    }
}
export function surveyModuleInventory(modules) {
    return new SurveyModuleInventory(modules);
}
//# sourceMappingURL=SurveyInventory.js.map